// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import promise from 'es6-promise'
import VueAMap from "vue-amap";
promise.polyfill()
window._AMapSecurityConfig = {
  securityJsCode: 'ff9bd65e5f0891f8b909977f7b247225',
}
Vue.use(ElementUI)
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  // 高德key
  key: "de59dc3c262858fc688153581db92748", // 自己到官网申请，我随便写的
  // 插件集合 （插件按需引入）
  plugin: ["AMap.Geolocation", "AMap.Geocoder"],
  v: "1.4.4", // 我也不知道为什么要写这个，不写项目会报错，而且我随便写的，跟我下载的版本对应不了
  uiVersion: "1.1", // ui版本号，也是需要写
});
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js